import { useEffect, useRef, useState } from 'react';

const useAutoResizeInput = (initialValue: string) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(initialValue);
  const [inputWidth, setInputWidth] = useState('auto');

  useEffect(() => {
    const input = inputRef.current;
    if (input) {
      // Create a temporary span element to calculate the width
      const span = document.createElement('span');
      span.style.visibility = 'hidden';
      span.style.whiteSpace = 'pre';
      span.style.font = getComputedStyle(input).font;
      span.textContent = input.value || input.placeholder || '';
      document.body.appendChild(span);
      setInputWidth(`${span.offsetWidth + 2}px`);
      document.body.removeChild(span);
    }
  }, [inputValue]);

  const handleChange = (text: string) => {
    setInputValue(text);
  };

  return {
    inputRef,
    inputValue,
    inputWidth,
    handleChange,
  };
};

export default useAutoResizeInput;
